import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/enviroments';
import { Comapnies, MyInfo, RequestNewPassClient, RequestUpdateContactClient, ResponseNewPassClient, ResponseUpdateContactClient } from '../data';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(private http: HttpClient) { }

  getMyInfo() : Observable<MyInfo> {
    const endpoint = `${environment.apiUrl}/ClientUser/me`;
    return this.http.get<MyInfo>(endpoint);
  }

  getMyCompanies(clientId: number) : Observable<Comapnies[]> {
    const endpoint = `${environment.apiUrl}/ClientUser/InfoCompanies/${clientId}`;
    return this.http.get<Comapnies[]>(endpoint);
  }

  updatePassUserClient(request: RequestNewPassClient) : Observable<ResponseNewPassClient> {
    const endpoint = `${environment.apiUrl}/ClientUser/ChangePassword`;
    return this.http.put<ResponseNewPassClient>(endpoint, request);
  }

  updateContactInfoClient(request: RequestUpdateContactClient) : Observable<ResponseUpdateContactClient> {
    const endpoint = `${environment.apiUrl}/ClientUser/UpdateInfoContact`;
    return this.http.put<ResponseUpdateContactClient>(endpoint, request);
  }

}
